<template>
  <div class="login-container">
    <header class="companyInfo">
      <div class="logoImg">
        <img v-if="companyType==1" style="width: 4%" src="../../assets/login/lgyLogo.png" alt >
        <img v-if="companyType==2" src="../../assets/login/ltLogo.png" alt >
        <img v-if="companyType==3" src="../../assets/login/jcLogo.png" alt >
        <span v-if="companyType==4">顺丰运力</span>
      </div>
      <div class="companyName">
        <span v-if="companyType==1">乐管油</span>
        <span v-if="companyType==2">山东隆泰</span>
        <span v-if="companyType==3">金城</span>
        <span v-if="companyType==4">顺丰运力</span>
      </div>
      <div class="platFormName">智慧加油站管理系统</div>
    </header>
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="user-login">
        <el-form-item prop="username">
          <span class="svg-container svg-container_login">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            name="username"
            type="text"
            auto-complete="off"
            maxlength="20"
            minlength="5"
          />
        </el-form-item>

        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :type="passwordType"
            v-model="loginForm.password"
            placeholder="请输入密码"
            name="password"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width:100%;margin-bottom:30px;"
          @click.native.prevent="handleLogin"
        >{{ $t('login.logIn') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
// import { isvalidUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import SocialSign from './socialsignin'
import ScrollPane from '@/components/ScrollPane'

export default {
  name: 'Login',
  components: { LangSelect, SocialSign },
  data () {
    /*    const validateUsername = (rule, value, callback) => {
          if (!isvalidUsername(value)) {
            // callback(new Error('请输入正确的用户名'))
          } else {
            callback()
          }
        }*/
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码至少6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message: '用户名不能为空！' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      companyType: 1
    }
  },
  created () {
    // 根据域名判断来源
    const API_SERVER = window.location.href
    const index = API_SERVER.indexOf('#')
    const url = API_SERVER.substring(0, index)
    console.log(url)
    if (url == 'http://sdlt.jtleguanyou.com/') {
      this.companyType = 2
    } else if (url == 'http://jc.jtleguanyou.com/') {
      this.companyType = 3
    } else if (url == 'http://sfyl.jtleguanyou.com/') {
      this.companyType = 4
    } else {
      this.companyType = 1
    }
  },
  destroyed () {},
  methods: {
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('LoginByUsername', this.loginForm)
            .then(() => {
              this.loading = false
              this.$router.push({ path: '/' })
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    //color: $cursor;
    color: white;

    &::first-line {
      //color: $light_gray;
      color: white;
    }
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      //color: $light_gray;
      color: white;
      height: 47px;
      //caret-color: $cursor;
      caret-color: white;

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #ddd;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-image: url('~@/assets/login/bg1.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .companyInfo {
    /*margin-top: 12%;*/
    color: #fff;
    font-weight: bold;
    letter-spacing: 5px;
    .logoImg {
      padding-left: 12%;
      margin-top: 10%;
    }
    .logoImg img {
      width: 3%;
    }
    .companyName {
      text-align: center;
      font-size: 38px;
    }
    .platFormName {
      margin-top: 20px;
      text-align: center;
      font-size: 28px;
      color: #666;
    }
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 500px;
    //top: 30%;
    top: 32%;
    //padding: 35px 35px 15px 35px;
    margin: 120px auto;
    /*background-image: url("~@/assets/login/bg.png");*/
    //height: 428px;
    .el-form-item__content {
      input:-webkit-autofill {
        color: red;
        //-webkit-box-shadow: 0 0 0px 1000px orangered inset;
        &::placeholder {
          color: red;
        }
      }
    }

    .user-login {
      position: relative;
      padding: 35px 35px 15px 35px;
      top: -60px;
      /*background-color: #fff;*/
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;

    &_login {
      font-size: 20px;
    }
  }

  .title-container {
    position: relative;
    /*background-image: url("~@/assets/login/logo.png");*/
    height: 57px;
    background-repeat: no-repeat;
    margin-bottom: 60px;
    background-position: 26%;

    .title {
      font-size: 22px;
      color: $light_gray;
      text-align: right;
      padding-right: 18%;
      font-weight: bold;
      line-height: 60px;
    }

    .set-language {
      color: #fff;
      position: absolute;
      top: 5px;
      right: 0px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }

  .el-input input {
    color: #fff;
  }
}
</style>
<style>
.login-container .el-input input::first-line {
  color: white;
}
</style>
